module.exports = __webpack_public_path__ + "img/houseVirtualrowFSFB.77337b6a.svg";